export default "__VITE_ASSET__CsdQn3hC__"